module.exports = __webpack_public_path__ + "static/img/15.b641a9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/15.png
// module id = ZV8N
// module chunks = 0